export default {
  sm: `
  Earning CSA STAR GOLD certification for 
  the first time in the nation’s history, we are 
  recognized worldwide for cloud 
  technologies while being qualified to
  provide services for public institutions
  with CSAP laaS·SaaS Certification.    
  `,
  md: `
  Earning CSA STAR GOLD certification for 
  the first time in the nation’s history, we are 
  recognized worldwide for cloud 
  technologies while being qualified to
  provide services for public institutions with 
  CSAP laaS·SaaS Certification.    
  `,
  lg: `
  Earning CSA STAR GOLD certification for the first time in 
  the nation’s history, we are 
  recognized worldwide for cloud technologies while being 
  qualified to provide services for public institutions with 
  CSAP laaS·SaaS Certification.    
  `,
  xxl: `
  Earning CSA STAR GOLD certification for the
  first time in the nation’s history, we are 
  recognized worldwide for cloud technologies
  while being qualified to provide services for
  public institutions with CSAP laaS·SaaS 
  Certification.    
  `,
};
